<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Requests
      p(class="category") Open requests to join fund
    md-card-content(v-if="requests.length == 0" style="text-align: center;")
      p There are currently no open requests for your fund.
    md-card-content(v-else style="text-align: center;")
      md-table
        md-table-row
          md-table-cell <b>Name</b>
          md-table-cell
        md-table-row(v-for="request in requests" :key="request.id")
          md-table-cell {{request.member.full_name}}
          md-table-cell(style="padding-left: 15px;")
            md-button(@click="viewRequest(request)") View Request
      p(v-if="error" style="color: red") Sorry, there was an error. Please try again later.
    FundRequestsForm
</template>

<script>
import axios from 'axios';
import FundRequestsForm from './FundRequestsForm';

export default {
  data() {
    return {
      user: null,
      requests: null,
      error: null,
    }
  },
  components: {
    FundRequestsForm
  },
  props: {
    groupID: {
      type: Number,
      default: null
    }
  },
  created() {
    this.$bus.$on('fund:refresh', () => {
      this.getGroupInformation();
    })
  },
  mounted() {
    this.user = this.$store.state.user;
    this.getGroupInformation();
  },
  methods: {
    getGroupInformation() {
      axios.get(`/api/org/fund_requests?fund_id=${this.groupID}`)
      .then((res) => {
        this.requests = res.data;
      }).catch(() => {
        this.error = true;
      })
    },
    viewRequest(request) {
      this.$bus.$emit('request:view', request);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Fund/FundRequests.vue